import { render, staticRenderFns } from "./FeedSchedule.vue?vue&type=template&id=67405cac"
import script from "./FeedSchedule.vue?vue&type=script&lang=ts"
export * from "./FeedSchedule.vue?vue&type=script&lang=ts"
import style0 from "./FeedSchedule.vue?vue&type=style&index=0&id=67405cac&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports